<template>
    <div v-if="hasAccessToContributors && contributors" class="grid-narrow-left-column SectionBorderTop">
        <loader :loading="true" v-if="loading"></loader>
        <div class="left"></div>
        <div class="right">
            <div class="row">
                <div class="col-sm-3">
                    <div class="SectionTitle">Forecast Managers</div>
                    <div v-for="(fcm, index) in contributors.forecastManagers" :key="`fcm+${index}`">
                        <MailIcon class="mailIcon" /><a :href="`mailto:${fcm.email}`">{{ fcm.name }}</a>
                    </div>
                </div>
                <div class="col-sm-3">
                    <template v-if="forecastWindow.multiValidation">
                        <div class="SectionTitle">Export Managers</div>
                        <div v-for="(zs, index) in contributors.zonesSupervisors" :key="`zs+${index}`">
                            <MailIcon class="mailIcon" /><a :href="`mailto:${zs.email}`">{{ zs.name }}</a>
                        </div>
                    </template>
                </div>
                <div class="col-sm-3">
                    <div class="SectionTitle">Contributors</div>
                    <div v-for="(zf, index) in contributors.zoneForecasters" :key="`zf+${index}`">
                        <MailIcon class="mailIcon" /><a :href="`mailto:${zf.email}`">{{ zf.name }}</a>
                    </div>
                    <template v-if="contributors.zoneReaders.length > 0">
                        <div class="SectionTitle" style="margin-top: 5px">Readers</div>
                        <div v-for="(zf, index) in contributors.zoneReaders" :key="`zr+${index}`">
                            <MailIcon class="mailIcon" /><a :href="`mailto:${zf.email}`">{{ zf.name }}</a>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import forecastsService from "@/components/forecasts/forecastsService";
import { PROFILES } from "@/plugins/AccessUserPlugin";
import loader from "@/components/loader/loader";
import MailIcon from "@/components/forecasts/elements/icons/MailIcon";

export default {
    components: { loader, MailIcon },
    props: {
        forecastWindow: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            contributors: null,
            loading: false
        };
    },
    async created() {
        if (this.hasAccessToContributors) {
            this.loading = true;
            this.contributors = await forecastsService.getForecastWindowContributors(this.forecastWindow);
            this.loading = false;
        }
    },
    computed: {
        hasAccessToContributors() {
            return this.isZonesSupervisor || this.isForecastManager;
        },
        isForecastManager() {
            return this.hasAccessByProfile(PROFILES.FORECAST_MANAGER);
        },
        isZonesSupervisor() {
            return this.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR);
        }
    }
};
</script>
<style scoped lang="scss">
@import "../../css/forecasts";
@import "../../../../assets/css/themes.scss";
a {
    text-decoration: none;
    color: $client-color2;
}
.mailIcon {
    display: inline-block;
    width: 20px;
    margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// Contributors.vue?37df1713